import { NotificationIdentifier } from '@evorait/pace-core';
import { FormsConstants } from '../types/forms-constants';
import SUBMIT_STATUS = FormsConstants.SUBMIT_STATUS;

export class FormListUtilities {
    private static readonly FORM_FINAL_STATUS = [
        SUBMIT_STATUS.FINAL,
        SUBMIT_STATUS.FINAL_NOT_OK,
        SUBMIT_STATUS.HANDOVER,
        SUBMIT_STATUS.ABORTED,
    ];
    private static readonly FORM_SUBMITTED_STATUS = [
        ...FormListUtilities.FORM_FINAL_STATUS,
        SUBMIT_STATUS.INTERIM,
        SUBMIT_STATUS.INTERIM_NOT_OK,
    ];

    private static readonly FORM_EDITED_STATUS = [
        ...FormListUtilities.FORM_SUBMITTED_STATUS,
        SUBMIT_STATUS.EDITED,
        SUBMIT_STATUS.REFRESHED,
    ];

    public static generateListIdentifierFromNotification(notification: NotificationIdentifier): string {
        return `${notification.qmNum}-${notification.maNum}`;
    }

    public static isFormCompleted(status: SUBMIT_STATUS): boolean {
        return FormListUtilities.FORM_SUBMITTED_STATUS.includes(status);
    }

    public static isFormEdited(status: SUBMIT_STATUS): boolean {
        return FormListUtilities.FORM_EDITED_STATUS.includes(status);
    }

    public static isFormFinal(status: SUBMIT_STATUS): boolean {
        return FormListUtilities.FORM_FINAL_STATUS.includes(status);
    }
}
